import { ArrowsCounterClockwiseIcon, HardDriveIcon, SphereIcon } from "@phosphor-icons/react";

import Beacon from "@gx/dls/beacons/Beacon";
import FlexWrapper, { AlignItems, FlexWrap, JustifyContent } from "@gx/dls/containers/FlexWrapper";
import Icon, { IconVariant } from "@gx/dls/icons/Icon";
import MetricItem, { MetricItemVariant } from "@gx/dls/metrics/MetricItem";
import Text, { TextSize, TextWeight } from "@gx/dls/text/Text";
import Widget, { WidgetVariant } from "@gx/dls/widget/Widget";
import { SourceSyncStatus } from "@gx/ts-contracts/services/database/models/public_pb";

import {
  SYNC_STATUS_TO_BEACON_VARIANT_MAP,
  SYNC_STATUS_TO_TEXT_MAP,
  SYNC_STATUS_TO_TEXT_VARIANT_MAP,
} from "@/pages/sources/constants";

interface EditSourceOverviewMetricsProps {
  syncStatus: SourceSyncStatus;
  syncCount: string;
  projectCount: string;
  totalVolume: string;
}

const EditSourceOverviewMetrics = ({
  syncStatus,
  syncCount,
  projectCount,
  totalVolume,
}: EditSourceOverviewMetricsProps) => {
  return (
    <Widget variant={WidgetVariant.BASE} padding="6px 8px" fillWidth noHover>
      <FlexWrapper
        alignItems={AlignItems.CENTER}
        justifyContent={JustifyContent.SPACE_BETWEEN}
        gap={8}
        wrap={FlexWrap.WRAP}
      >
        <MetricItem
          label="Source status"
          value={
            <FlexWrapper gap={6} alignItems={AlignItems.CENTER}>
              <Beacon variant={SYNC_STATUS_TO_BEACON_VARIANT_MAP[syncStatus]} isPulse />
              <Text
                size={TextSize.BODY_LG}
                weight={TextWeight.MEDIUM}
                variant={SYNC_STATUS_TO_TEXT_VARIANT_MAP[syncStatus]}
              >
                {SYNC_STATUS_TO_TEXT_MAP[syncStatus]}
              </Text>
            </FlexWrapper>
          }
          variant={MetricItemVariant.BASE}
          noBorder
        />
        <FlexWrapper gap={8} alignItems={AlignItems.CENTER}>
          <MetricItem
            label="Num projects"
            value={
              <FlexWrapper gap={6} alignItems={AlignItems.CENTER}>
                <Text size={TextSize.BODY_LG} weight={TextWeight.MEDIUM}>
                  {projectCount}
                </Text>
                <Icon component={SphereIcon} size={14} variant={IconVariant.TERTIARY} />
              </FlexWrapper>
            }
            variant={MetricItemVariant.PRIMARY}
          />
          <MetricItem
            label="Num syncs"
            value={
              <FlexWrapper gap={6} alignItems={AlignItems.CENTER}>
                <Text size={TextSize.BODY_LG} weight={TextWeight.MEDIUM}>
                  {syncCount}
                </Text>
                <Icon
                  component={ArrowsCounterClockwiseIcon}
                  size={14}
                  variant={IconVariant.TERTIARY}
                />
              </FlexWrapper>
            }
            variant={MetricItemVariant.PRIMARY}
          />
          <MetricItem
            label="Total volume"
            value={
              <FlexWrapper gap={6} alignItems={AlignItems.CENTER}>
                <Text size={TextSize.BODY_LG} weight={TextWeight.MEDIUM}>
                  {totalVolume}
                </Text>
                <Icon component={HardDriveIcon} size={14} variant={IconVariant.TERTIARY} />
              </FlexWrapper>
            }
            variant={MetricItemVariant.TERTIARY}
          />
        </FlexWrapper>
      </FlexWrapper>
    </Widget>
  );
};

export default EditSourceOverviewMetrics;
